import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { AiOutlineSync } from "react-icons/ai";

import DatePicker from "react-datepicker";
import DataGrid, {
  Column,
  HeaderRendererProps,
  SortColumn,
  useFocusRef,
} from "react-data-grid";
import Select from "react-select";
import { API, graphqlOperation } from "aws-amplify";
import { searchProducts } from "../../graphql/queries";
import {
  brandOptions,
  Brands,
  BrandsFN,
  packagingOptions,
  productPackaging,
  ProductStatus,
  productStatusOptions,
  SyncType,
} from "../../constants/enum";

import { addMonths, format, subMonths } from "date-fns";
import EmptyRowsRenderer from "../../components/EmptyRow";
import FilterRowsRenderer from "../../components/Filter";
import ManualSync from "../../components/ManualSync";
import LoadingRowsRenderer from "../../components/Loading";
import { syncProduct } from "../../graphql/mutations";
import { ProductLibProduct } from "../../API";
import {
  getComparator,
  dataGridTabClassname,
  inputStopPropagation,
  filterClassname,
  styleDataGrid,
  filterColumnClassName,
  filterCellClass,
  selectStopPropagation,
} from "../../datagrid/extra";
import ModalConfirm from "../../components/ModalConfirm";
import ButtonPillBrand from "../../components/ButtonPillBrand";
import BadgeProductStatus from "../../components/BadgeProductStatus";
import Icon from "../../components/Icon";
import { Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { RiFileExcel2Line } from "react-icons/ri";
import { TbTableExport } from "react-icons/tb";
import { groupBy } from "../../components/GroupBy";
import { exportProductImport } from "../../utils/ExcelUtils";

interface Filter extends Omit<ProductLibProduct, "id"> {
  id: string;
  enabled: boolean;
}

const FilterContext = createContext<Filter | undefined>(undefined);

interface syncInterface {
  startDate: string;
  endDate: string;
  type?: string;
  brand?: string;
}

interface SummaryRow {
  id: string;
  totalCount: number;
}

function ControlPanalSyncProduct() {
  const [rows, setRows] = useState<any>([]);
  const [brand, setBrand] = useState<String>(Brands.FINELINE);
  const [syncBrand, setSyncBrand] = useState<string>("");
  const [defaultBrand] = useState<String>(BrandsFN.FL);
  const [packaging, setPackaging] = useState<String>(productPackaging.EA);
  const [defaultPackaging] = useState<String>(productPackaging.EA);
  const [startDate, setStartDate] = useState(
    new Date(Date.now() - 3600 * 1000 * 24)
  );
  // const [ startExportDate /* , setStartExportDate */ ] = useState(new Date("2023-12-01"));
  const [endDate, setEndDate] = useState(new Date());
  // const [ endExportDate /* , setEndExportDate */ ] = useState(new Date("2023-12-31"));
  const [disableSync, setDisableSync] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [showConfirmSync, setShowConfirmSync] = useState(false);
  const [showConfirmExport, setShowConfirmExport] = useState(false);

  const statusAll = "All";
  const [isLoading, setIsLoading] = useState(false);
  // const [ nextToken, setNextToken ] = useState<string>();
  const [sortColumns, setSortColumns] = useState<readonly SortColumn[]>([
    { columnKey: "updatedAt", direction: "DESC" },
  ]);

  const [filters, setFilters] = useState<Filter>({
    __typename: "ProductLibProduct",
    id: "",
    brand: "",
    brandType: "",
    materialCode: "",
    materialName: "",
    barcode: "",
    productHierachy: "",
    name: "",
    titleEN: "",
    titleTH: "",
    category: "",
    subcategory: "",
    collection: "",
    color: "",
    classifier: "",
    packaging: "",
    status: "",
    length: 0,
    width: 0,
    height: 0,
    weight: 0,
    weightUnit: "",
    // description: '',
    descriptionEN: "",
    descriptionTH: "",
    eaPerCase: 0,
    eaPerPack: 0,
    createdAt: "",
    updatedAt: "",
    enabled: false,
  });

  const dateFormat = "dd-MM-yyyy (HH:mm:ss)";
  const filteredRows = useMemo(() => {
    return rows.filter((r: any) => {
      return (
        (filters.id
          ? r.id
            ? r.id.toLocaleLowerCase().includes(filters.id.toLowerCase())
            : false
          : true) &&
        (filters.brand
          ? r.brand
            ? r.brand.toLocaleLowerCase().includes(filters.brand.toLowerCase())
            : false
          : true) &&
        (filters.brandType
          ? r.brandType
            ? r.brandType
                .toLocaleLowerCase()
                .includes(filters.brandType.toLowerCase())
            : false
          : true) &&
        (filters.materialCode
          ? r.materialCode
            ? r.materialCode
                .toLocaleLowerCase()
                .includes(filters.materialCode.toLowerCase())
            : false
          : true) &&
        (filters.materialName
          ? r.materialName
            ? r.materialName
                .toLocaleLowerCase()
                .includes(filters.materialName.toLowerCase())
            : false
          : true) &&
        (filters.barcode
          ? r.barcode
            ? r.barcode
                .toLocaleLowerCase()
                .includes(filters.barcode.toLowerCase())
            : false
          : true) &&
        (filters.productHierachy
          ? r.productHierachy
            ? r.productHierachy
                .toLocaleLowerCase()
                .includes(filters.productHierachy.toLowerCase())
            : false
          : true) &&
        (filters.name
          ? r.name
            ? r.name.toLocaleLowerCase().includes(filters.name.toLowerCase())
            : false
          : true) &&
        (filters.titleEN
          ? r.titleEN
            ? r.titleEN
                .toLocaleLowerCase()
                .includes(filters.titleEN.toLowerCase())
            : false
          : true) &&
        (filters.titleTH
          ? r.titleTH
            ? r.titleTH
                .toLocaleLowerCase()
                .includes(filters.titleTH.toLowerCase())
            : false
          : true) &&
        (filters.category
          ? r.category
            ? r.category
                .toLocaleLowerCase()
                .includes(filters.category.toLowerCase())
            : false
          : true) &&
        (filters.subcategory
          ? r.subcategory
            ? r.subcategory
                .toLocaleLowerCase()
                .includes(filters.subcategory.toLowerCase())
            : false
          : true) &&
        (filters.collection
          ? r.collection
            ? r.collection
                .toLocaleLowerCase()
                .includes(filters.collection.toLowerCase())
            : false
          : true) &&
        (filters.color
          ? r.color
            ? r.color.toLocaleLowerCase().includes(filters.color.toLowerCase())
            : false
          : true) &&
        (filters.classifier
          ? r.classifier
            ? r.classifier
                .toLocaleLowerCase()
                .includes(filters.classifier.toLowerCase())
            : false
          : true) &&
        (filters.packaging
          ? r.packaging
            ? r.packaging
                .toLocaleLowerCase()
                .includes(filters.packaging.toLowerCase())
            : false
          : true) &&
        (filters.status !== statusAll
          ? r.status
            ? r.status
                .toLocaleLowerCase()
                .includes(filters.status!.toLowerCase())
            : false
          : true) &&
        (filters.length
          ? r.length
            ? r.length.toLocaleLowerCase().includes(filters.length)
            : false
          : true) &&
        (filters.width
          ? r.width
            ? r.width.toLocaleLowerCase().includes(filters.width)
            : false
          : true) &&
        (filters.height
          ? r.height
            ? r.height.toLocaleLowerCase().includes(filters.height)
            : false
          : true) &&
        (filters.weight
          ? r.weight
            ? r.weight.toLocaleLowerCase().includes(filters.weight)
            : false
          : true) &&
        (filters.weightUnit
          ? r.weightUnit
            ? r.weightUnit
                .toLocaleLowerCase()
                .includes(filters.weightUnit.toLowerCase())
            : false
          : true) &&
        // (filters.description ? r.description ? r.description.toLocaleLowerCase().includes(filters.description.toLowerCase()) : false : true) &&
        (filters.descriptionEN
          ? r.descriptionEN
            ? r.descriptionEN
                .toLocaleLowerCase()
                .includes(filters.descriptionEN.toLowerCase())
            : false
          : true) &&
        (filters.descriptionTH
          ? r.descriptionTH
            ? r.descriptionTH
                .toLocaleLowerCase()
                .includes(filters.descriptionTH.toLowerCase())
            : false
          : true) &&
        (filters.eaPerCase
          ? r.eaPerCase
            ? r.eaPerCase.includes(filters.eaPerCase)
            : false
          : true) &&
        (filters.eaPerPack
          ? r.eaPerPack
            ? r.eaPerPack.includes(filters.eaPerPack)
            : false
          : true) &&
        (filters.createdAt
          ? r.createdAt
            ? format(new Date(r.createdAt), dateFormat)
                .toLocaleLowerCase()
                .includes(filters.createdAt.toLowerCase())
            : false
          : true) &&
        (filters.updatedAt
          ? r.updatedAt
            ? format(new Date(r.updatedAt), dateFormat)
                .toLocaleLowerCase()
                .includes(filters.updatedAt.toLowerCase())
            : false
          : true)
      );
    });
  }, [rows, filters]);

  function clearFilters() {
    setFilters({
      __typename: "ProductLibProduct",
      id: "",
      brand: "",
      brandType: "",
      materialCode: "",
      materialName: "",
      barcode: "",
      productHierachy: "",
      name: "",
      titleEN: "",
      titleTH: "",
      category: "",
      subcategory: "",
      collection: "",
      color: "",
      classifier: "",
      packaging: "",
      status: "",
      length: 0,
      width: 0,
      height: 0,
      weight: 0,
      weightUnit: "",
      // description: '',
      descriptionEN: "",
      descriptionTH: "",
      eaPerCase: 0,
      eaPerPack: 0,
      createdAt: "",
      updatedAt: "",
      enabled: false,
    });
  }

  function toggleFilters() {
    setFilters((filters) => ({
      ...filters,
      enabled: !filters.enabled,
    }));
  }

  const sortedRows = useMemo((): readonly ProductLibProduct[] => {
    if (sortColumns.length === 0) return filteredRows;

    return [...filteredRows].sort((a, b) => {
      for (const sort of sortColumns) {
        const comparator = getComparator(sort.columnKey);
        const compResult = comparator(a, b);
        if (compResult !== 0) {
          return sort.direction === "ASC" ? compResult : -compResult;
        }
      }
      return 0;
    });
  }, [filteredRows, sortColumns]);

  const summaryRows = useMemo(() => {
    const summaryRow: SummaryRow = {
      id: "total_0",
      totalCount: sortedRows.length,
    };
    return [summaryRow];
  }, [sortedRows]);

  async function triggerSyncFn() {
    setIsLoading(true);
    // setRows([]);
    // 20230301
    const syncParam: syncInterface = {
      startDate: format(startDate, "yyyyMMdd"),
      endDate: format(endDate, "yyyyMMdd"),
      // startDate: "20250105",
      // endDate: "20250107",
      type: SyncType.INCREMENTAL,
    };

    if (syncBrand) syncParam["brand"] = syncBrand;

    console.log("syncParam : ", syncParam);

    // setShowConfirmSync(false)
    // setShowDialog(true)

    let response = await API.graphql(graphqlOperation(syncProduct, syncParam));

    if (response) {
      // fetchProductData(brand, packaging);
      setIsLoading(false);
      setShowConfirmSync(false);
      setShowDialog(true);
      console.log("res : ", response);
    } else {
      console.log("error : ", response);
    }
  }

  const exportExcelProduct = async () => {
    setIsLoading(true);

    let from = 0;
    let localProducts: any = [];
    const PAGE = 1000;

    while (true) {
      let result: any = await API.graphql(
        graphqlOperation(searchProducts, {
          category: "-",
          packaging: "EA",
          statuses: [
            ProductStatus.Launch,
            ProductStatus.Normal,
            ProductStatus.TobeDiscontinued,
          ],
          limit: PAGE,
          from,
        })
      );
      const items = result.data?.searchProducts?.items || [];
      localProducts = [...localProducts, ...items];
      if (items.length < PAGE) break;
      from += PAGE;
    }

    const localProductByCategory = groupBy(localProducts, "materialCode");
    exportProductImport(
      `ProductExport_${format(startDate, "yyyyMMdd")}`,
      localProductByCategory
    );

    setShowConfirmExport(false);
    setIsLoading(false);
  };

  const fetchProductData = async (filterBrand: String, packaging: String) => {
    const key = `${filterBrand}`;
    const pPackaging = `${packaging}`;

    console.log("key : ", key);
    console.log("pPackaging : ", pPackaging);

    let result: any = await API.graphql(
      graphqlOperation(searchProducts, {
        brand: key,
        packaging: pPackaging,
        limit: 1000,
        from: 0,
      })
    );

    console.log("result : ", result);
    if (result) setRows(result.data.searchProducts.items);
    else setRows([]);
  };

  const syncProductColumn: Column<ProductLibProduct, SummaryRow>[] = [
    {
      key: "barcode",
      name: "Barcode",
      width: 140,
      sortable: true,
      headerCellClass: filterColumnClassName,
      cellClass: filterCellClass,
      formatter: ({ row }) => (
        <Link
          to={`product/${row.id}/edit`}
          className={" text-violet-400 hover:text-violet-600 font-bold"}
        >
          {row.barcode}
        </Link>
      ),
      summaryFormatter({ row }) {
        return (
          <div className="opacity-50">
            <strong>({row.totalCount} Rows)</strong>
          </div>
        );
      },
      headerRenderer: (p) => (
        <FilterRenderer<ProductLibProduct, SummaryRow, HTMLInputElement> {...p}>
          {({ filters, ...rest }) => (
            <input
              {...rest}
              className={filterClassname}
              value={filters.barcode ? filters.barcode : ""}
              onChange={(e) => {
                console.log("e : ", e);
                setFilters({
                  ...filters,
                  barcode: e.target.value,
                });
              }}
              onKeyDown={inputStopPropagation}
            />
          )}
        </FilterRenderer>
      ),
    },
    {
      key: "productHierachy",
      name: "Pro Hierachy",
      width: 155,
      headerCellClass: filterColumnClassName,
      cellClass: filterCellClass,
      headerRenderer: (p) => (
        <FilterRenderer<ProductLibProduct, SummaryRow, HTMLInputElement> {...p}>
          {({ filters, ...rest }) => (
            <input
              {...rest}
              className={filterClassname}
              value={filters.productHierachy ? filters.productHierachy : ""}
              onChange={(e) => {
                console.log("e : ", e);
                setFilters({
                  ...filters,
                  productHierachy: e.target.value,
                });
              }}
              onKeyDown={inputStopPropagation}
            />
          )}
        </FilterRenderer>
      ),
    },
    {
      key: "brand",
      name: "Brand",
      width: 120,
      headerCellClass: filterColumnClassName,
      cellClass: filterCellClass,
      formatter: ({ row }) => (
        <div className="text-center align-middle items-center">
          <ButtonPillBrand brand={row.brand} textSize="text-[0.9rem]" />
        </div>
      ),
      headerRenderer: (p) => (
        <>
          <div className="mt-1 text-center">Brand</div>
        </>
      ),
    },
    {
      key: "brandType",
      name: "Brand Type",
      width: 140,
      resizable: true,
      sortable: true,
      headerCellClass: filterColumnClassName,
      cellClass: filterCellClass,
      formatter: ({ row }) => (
        <div className="text-center">{row.brandType}</div>
      ),
      headerRenderer: (p) => (
        <FilterRenderer<ProductLibProduct, SummaryRow, HTMLInputElement> {...p}>
          {({ filters, ...rest }) => (
            <input
              {...rest}
              className={filterClassname}
              value={filters.brandType ? filters.brandType : ""}
              onChange={(e) => {
                setFilters({
                  ...filters,
                  brandType: e.target.value,
                });
              }}
              onKeyDown={inputStopPropagation}
            />
          )}
        </FilterRenderer>
      ),
    },
    {
      key: "materialCode",
      name: "Mat Code",
      width: 125,
      sortable: true,
      headerCellClass: filterColumnClassName,
      cellClass: filterCellClass,
      formatter: ({ row }) => (
        <div className="text-center">
          <Link
            to={`product/${row.id}/edit`}
            className={" text-violet-400 hover:text-violet-600 font-bold"}
          >
            {row.materialCode}
          </Link>
        </div>
      ),
      headerRenderer: (p) => (
        <FilterRenderer<ProductLibProduct, SummaryRow, HTMLInputElement> {...p}>
          {({ filters, ...rest }) => (
            <input
              {...rest}
              className={filterClassname}
              value={filters.materialCode ? filters.materialCode : ""}
              onChange={(e) => {
                setFilters({
                  ...filters,
                  materialCode: e.target.value,
                });
              }}
              onKeyDown={inputStopPropagation}
            />
          )}
        </FilterRenderer>
      ),
    },
    {
      key: "titleEN",
      name: "Title EN",
      resizable: true,
      sortable: true,
      headerCellClass: filterColumnClassName,
      cellClass: filterCellClass,
      headerRenderer: (p) => (
        <FilterRenderer<ProductLibProduct, SummaryRow, HTMLInputElement> {...p}>
          {({ filters, ...rest }) => (
            <input
              {...rest}
              className={filterClassname}
              value={filters.titleEN ? filters.titleEN : ""}
              onChange={(e) => {
                console.log("e : ", e);
                setFilters({
                  ...filters,
                  titleEN: e.target.value,
                });
              }}
              onKeyDown={inputStopPropagation}
            />
          )}
        </FilterRenderer>
      ),
    },
    {
      key: "titleTH",
      name: "Title TH",
      resizable: true,
      sortable: true,
      headerCellClass: filterColumnClassName,
      cellClass: filterCellClass,
      headerRenderer: (p) => (
        <FilterRenderer<ProductLibProduct, SummaryRow, HTMLInputElement> {...p}>
          {({ filters, ...rest }) => (
            <input
              {...rest}
              className={filterClassname}
              value={filters.titleEN ? filters.titleEN : ""}
              onChange={(e) => {
                console.log("e : ", e);
                setFilters({
                  ...filters,
                  titleEN: e.target.value,
                });
              }}
              onKeyDown={inputStopPropagation}
            />
          )}
        </FilterRenderer>
      ),
    },
    {
      key: "eaPerCase",
      name: "EA/Case",
      resizable: true,
      sortable: true,
      headerCellClass: filterColumnClassName,
      cellClass: filterCellClass,
      headerRenderer: (p) => (
        <FilterRenderer<ProductLibProduct, SummaryRow, HTMLInputElement> {...p}>
          {({ filters, ...rest }) => (
            <input
              {...rest}
              className={filterClassname}
              value={filters.eaPerCase ? filters.eaPerCase : ""}
              onChange={(e) => {
                console.log("e : ", e);
                setFilters({
                  ...filters,
                  eaPerCase: Number(e.target.value),
                });
              }}
              onKeyDown={inputStopPropagation}
            />
          )}
        </FilterRenderer>
      ),
    },
    {
      key: "eaPerPack",
      name: "EA/Pack",
      resizable: true,
      sortable: true,
      headerCellClass: filterColumnClassName,
      cellClass: filterCellClass,
      headerRenderer: (p) => (
        <FilterRenderer<ProductLibProduct, SummaryRow, HTMLInputElement> {...p}>
          {({ filters, ...rest }) => (
            <input
              {...rest}
              className={filterClassname}
              value={filters.eaPerPack ? filters.eaPerPack : ""}
              onChange={(e) => {
                console.log("e : ", e);
                setFilters({
                  ...filters,
                  eaPerPack: Number(e.target.value),
                });
              }}
              onKeyDown={inputStopPropagation}
            />
          )}
        </FilterRenderer>
      ),
    },
    {
      key: "status",
      name: "Status",
      width: 190,
      sortable: true,
      headerCellClass: filterColumnClassName,
      cellClass: filterCellClass,
      formatter: ({ row }) => {
        return (
          <div className="items-center text-center">
            <BadgeProductStatus
              status={row.status || ""}
              textSize="text-[0.9rem]"
            />
          </div>
        );
      },
      headerRenderer: (p) => (
        <FilterRenderer<ProductLibProduct, SummaryRow, HTMLSelectElement>
          {...p}
        >
          {({ filters, ...rest }) => (
            <select
              {...rest}
              className={filterClassname}
              value={filters.status ? filters.status : ""}
              onChange={(e) =>
                setFilters({
                  ...filters,
                  status: e.target.value,
                })
              }
              onKeyDown={selectStopPropagation}
            >
              <option key={statusAll} value={statusAll}>
                {statusAll.toUpperCase()}
              </option>
              {productStatusOptions.map((status) => (
                <option key={status.label} value={status.value}>
                  {status.label}
                </option>
              ))}
            </select>
          )}
        </FilterRenderer>
      ),
    },
    {
      key: "updatedAt",
      name: "Updated At",
      width: 170,
      sortable: true,
      headerCellClass: filterColumnClassName,
      cellClass: filterCellClass,
      formatter: ({ row }) => {
        return (
          <div className="items-center">
            {/* { row.updatedAt} */}
            {format(new Date(row.updatedAt), dateFormat)}
          </div>
        );
      },
      headerRenderer: (p) => (
        <FilterRenderer<ProductLibProduct, SummaryRow, HTMLInputElement> {...p}>
          {({ filters, ...rest }) => <></>}
        </FilterRenderer>
      ),
    },
    {
      key: "id",
      name: "Action",
      width: 80,
      headerCellClass: filterColumnClassName,
      cellClass: filterCellClass,
      formatter: ({ row }) => (
        <Link
          to={`product/${row.id}/edit`}
          className={" text-violet-400 hover:text-violet-600 font-bold"}
        >
          Update
        </Link>
      ),
      headerRenderer: (p) => (
        <>
          <div className="mt-1 text-center">Action</div>
        </>
      ),
    },
  ];

  useEffect(() => {
    if (brand) {
      console.log("brand : ", brand);
      console.log("packaging : ", packaging);
      fetchProductData(brand, packaging);
      return;
    }
  }, [brand, packaging]);

  return (
    <>
      <ModalConfirm
        show={showDialog}
        onHide={() => {}}
        title="Result sync SAP"
        cancelText={"Close"}
        cancelAction={() => {
          setShowDialog(false);
          setShowConfirmSync(false);
          setIsLoading(false);
        }}
        okClass="btn-submit"
        maxWidth="max-w-4xl"
      >
        <div className="flex flex-col items-center justify-center mb-2 space-y-2 text-center">
          <strong>Sent sync sap actions done</strong>
          <p>Please wait 1-2 mins then refresh screen for new data ...</p>
        </div>
      </ModalConfirm>

      <ModalConfirm
        show={showConfirmSync}
        onHide={() => {}}
        title="Sync sap Confirmation !!"
        cancelText={"Close"}
        cancelAction={() => setShowConfirmSync(false)}
        okText={"Confirm"}
        loading={isLoading}
        okAction={() => {
          // onSubmit(dataForm)
          triggerSyncFn();
          setIsLoading(true);
        }}
        okClass="btn-submit"
        maxWidth="max-w-md"
      >
        <>
          <div className="flex flex-col items-center justify-center mb-2 space-y-2 text-center">
            <AiOutlineSync size={36} color="rgb(167 139 250)" />
            <h6>Do you want to sync product master from sap</h6>
            <h6>{syncBrand ? `Brand : ${syncBrand}` : ""}</h6>
            <h6>{`period : ${format(startDate, "yyyyMMdd")} - ${format(
              endDate,
              "yyyyMMdd"
            )}`}</h6>
          </div>
        </>
      </ModalConfirm>

      <ModalConfirm
        show={showConfirmExport}
        onHide={() => {}}
        title="Export product excel file Confirmation !!"
        cancelText={"Close"}
        cancelAction={() => setShowConfirmExport(false)}
        okText={"Confirm"}
        loading={isLoading}
        okAction={() => {
          console.log("okAction");
          exportExcelProduct();
          setIsLoading(true);
        }}
        okClass="btn-submit"
        maxWidth="max-w-md"
      >
        <>
          <div className="flex flex-col items-center justify-center mb-2 space-y-2 text-center">
            <TbTableExport size={36} color="#10b981" />
            <h6>Do you want to export excel for re-import product ?</h6>
          </div>
        </>
      </ModalConfirm>

      <div>
        <div className="page-container-title">
          <div className="grid grid-cols-3 gap-0.5 md:gap-1 items-center sm:page-container-only-button ">
            {/* <AiFillFilter size={24} color="rgb(167 139 250)"/> */}
            <p className="font-bold">Filter : </p>
            <Select
              className="font-normal text-sm"
              classNamePrefix="select"
              placeholder="เลือก Packaging"
              isSearchable={true}
              defaultValue={{ label: defaultPackaging, value: packaging }}
              isClearable={false}
              isDisabled={false}
              options={packagingOptions.map((packaging) => ({
                label: `${packaging.label}`,
                value: packaging.value,
              }))}
              onChange={(vals) => setPackaging(vals?.value!)}
            />
            <Select
              className="font-normal text-sm"
              classNamePrefix="select"
              placeholder="เลือก brand"
              isSearchable={true}
              defaultValue={{ label: defaultBrand, value: brand }}
              isClearable={false}
              isDisabled={false}
              options={brandOptions.map((brand) => ({
                label: `${brand.label}`,
                value: brand.value,
              }))}
              onChange={(vals) => setBrand(vals?.value!)}
            />
          </div>

          <div className="gap-0.5 items-center py-0 sm:gap-1 sm:py-1 sm:page-container-right">
            <p className="font-bold hidden sm:block">Sync : </p>
            <div className="gap-0.5 py-0.5 grid grid-cols-3 sm:flex sm:flex-row sm:gap-1 sm:py-0">
              <p className="font-bold sm:hidden">Sync : </p>
              <DatePicker
                selected={startDate}
                onChange={(date: any) => {
                  if (date) {
                    setStartDate(date);
                    if (date > endDate) setDisableSync(true);
                    else setDisableSync(false);
                  }
                }}
                selectsStart
                startDate={startDate}
                endDate={endDate}
                minDate={subMonths(startDate, 1)}
                maxDate={addMonths(startDate, 1)}
                className="form-input w-full sm:w-28"
              />
              <DatePicker
                selected={endDate}
                onChange={(date: any) => {
                  if (date) {
                    setEndDate(date);
                    if (startDate > date) setDisableSync(true);
                    else setDisableSync(false);
                  }
                }}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                maxDate={addMonths(startDate, 1)}
                className="form-input w-full sm:w-28"
              />
            </div>
            <div className="flex flex-row gap-0.5 sm:gap-1">
              <Select
                className="font-normal text-sm w-full"
                classNamePrefix="select"
                placeholder="brand ?"
                isSearchable={true}
                isDisabled={false}
                isClearable={true}
                options={brandOptions as any}
                // defaultValue={{ label: BrandsFN.FL, value: Brands.FINELINE}}
                onChange={(vals: any) => setSyncBrand(vals?.value!)}
              />
              <ManualSync
                setShowConfirmSync={setShowConfirmSync}
                isDisabled={disableSync}
              />
            </div>
          </div>
        </div>
        <div className="flex flex-wrap items-center justify-between mb-3">
          <FilterRowsRenderer
            toggleFilters={toggleFilters}
            clearFilters={clearFilters}
            activeFilters={filters}
          />
          <button
            type="button"
            className="flex btn-manual-export"
            onClick={() => setShowConfirmExport(true)}
          >
            <RiFileExcel2Line className={`mr-3`} size={20} />
            Export
          </button>
        </div>

        <FilterContext.Provider value={filters}>
          <DataGrid
            columns={syncProductColumn}
            rows={sortedRows}
            bottomSummaryRows={summaryRows}
            renderers={{ noRowsFallback: <EmptyRowsRenderer /> }}
            style={{ height: "60vh" }}
            headerRowHeight={filters.enabled ? 100 : 50}
            sortColumns={sortColumns}
            onSortColumnsChange={setSortColumns}
            className={dataGridTabClassname}
          />
          <div className="loading-renderer">
            {isLoading && <LoadingRowsRenderer />}
          </div>
        </FilterContext.Provider>
        <style>{styleDataGrid}</style>
      </div>
    </>
  );
}

function FilterRenderer<R, SR, T extends HTMLOrSVGElement>({
  isCellSelected,
  onSort,
  sortDirection,
  column,
  children,
}: HeaderRendererProps<R, SR> & {
  children: (args: {
    ref: React.RefObject<T>;
    tabIndex: number;
    filters: Filter;
  }) => React.ReactElement;
}) {
  const filters = useContext(FilterContext)!;
  const { ref, tabIndex } = useFocusRef<T>(isCellSelected);
  return (
    <>
      <div
        className="flex flex-row"
        onClick={() => {
          onSort(false);
        }}
      >
        <div className="flex flex-row mt-1 ml-2 mr-auto text-truncate">
          <span>{column.name}</span>
        </div>
        <div className="mt-5">
          {sortDirection === "ASC" && <Icon name="sort-alpha-down" />}
          {sortDirection === "DESC" && <Icon name="sort-alpha-up" />}
          {sortDirection !== "DESC" && sortDirection !== "ASC" && (
            <Icon name="arrows-alt-v" />
          )}
        </div>
      </div>
      {filters.enabled && (
        <div className="">{children({ ref, tabIndex, filters })}</div>
      )}
    </>
  );
}

export default ControlPanalSyncProduct;
